// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__1BcEj","label":"SetPasswdForm_label__1HUVN"};